<script>
    import { createEventDispatcher, onMount } from "svelte";
    import Conexoes from "../Classes/Conexoes";
    import Constantes from "../Classes/Constantes";
    import { ItemInserir, Tipo } from "../Classes/ItemInserir";
    import CaixaDeDialogo from "./CaixaDeDialogo.svelte";
    import LoadingTela from "./LoadingTela.svelte";
    import { Notification, Button, Input } from "@svelteuidev/core";
    import { fade } from "svelte/transition";
    import { ConfirmaEmail } from "../Classes/Stores";
    export let showModal = false;
    let msgConfirmacao = "Digite seu email para redefinir a senha";
    let token = "";
    let novaSenha = "";
    let confirmarSenha = "";
    let titulo = "Redefinir Senha";
    let mensagemToast;
    let confirmou = true;
    let email = "";
    let etapa = "email"; // Etapas: email, token, senha
    let api = Constantes.api_consultar_sem_retorno;
    let cor = "red";
    function Sucesso() {
        if (etapa === "token") {
            etapa = "senha";
            msgConfirmacao = "Digite sua nova senha";
        } else if (etapa === "senha") {
            cor = "blue";
            mensagemToast = "Senha alterada com sucesso!";
            
            setTimeout(() => {
                showModal = false;
            }, 1000);
        }
        confirmou = true;
    }

    function NaoConfirmado() {
        msgConfirmacao =
            "Token inválido, digite novamente ou clique em reenviar token";
        mensagemToast =
            "Token inválido, por favor, verifique e tente novamente.";
        setTimeout(() => {
            mensagemToast = "";
        }, 3000);
        confirmou = false;
    }

    let conexao = new Conexoes();
    let resultado;
    let carregando = false;
    let showNotification = true;

    async function VerificarEmail() {
        carregando = true;

        resultado = await conexao.conecta(Constantes.api_consultar_sem_retorno, {
            query_code: "consultar_email",
            email: email,
        });
        carregando = false;

        if (resultado && resultado.retornou) {
            etapa = "token";
            msgConfirmacao =
                "Token de confirmação enviado para seu email e telefone";
            await Reenviar();
        } else {
            mensagemToast = "Email não encontrado, por favor, verifique.";
            setTimeout(() => {
                mensagemToast = "";
            }, 3000);
        }
    }
  async function EnviaSMS() {
        carregando = true;

        resultado = await conexao.conecta(Constantes.api_enviar_email_sms, {});
        carregando = false;
    }


    async function ConfirmaToken() {
        carregando = true;

        resultado = await conexao.conecta(api, {
            query_code: "confirma_token_nova_senha",
            token_confirmacao: token,
            email: email,
        });
        carregando = false;

        let confirmou = false;
        if (resultado && resultado.retornou) {
            confirmou = true;
        }
        if (confirmou) {
            Sucesso();
        } else {
            NaoConfirmado();
        }
    }

    async function AlterarSenha() {
        carregando = true;

        resultado = await conexao.conecta(Constantes.api_consultar_sem_retorno, {
            query_code: "alterar_senha",
            email: email,
            nova_senha: novaSenha,
        });
        carregando = false;

        if (resultado && resultado.retornou) {
            Sucesso();
        }
    }

    function closeDialog() {
        showModal = false;
       
    }

    async function Reenviar() {
        carregando = true;

        resultado = await conexao.conecta(api, {
            query_code: "reenvia_token_esqueceu_senha",
            email: email,
        });
        carregando = false;

        let confirmou = false;
        if (resultado) {
            if (resultado[0]) {
                if (resultado[0].id) {
                    confirmou = true;
                }
            }
        }

        await EnviaSMS();
    }
</script>

{#if mensagemToast && showNotification}
    <div transition:fade class="notification-container">
        <Notification title="Atenção" color="{cor}">
            {mensagemToast}
        </Notification>
    </div>
{/if}


{#if showModal} 
<LoadingTela isLoading={carregando} /> 

    <div class="modal">
        <div class="modal-content">
            <div class="modal-header">
                <h2>{titulo}</h2>
                <button class="close-button" on:click={closeDialog}
                    >&times;</button
                >
            </div>
            <div class="modal-body">
                {#if etapa === "email"}
                    <p>{msgConfirmacao}</p>
                    <Input
                        type="email"
                        bind:value={email}
                        placeholder="Digite seu email"
                    />
                {/if}
                {#if etapa === "token"}
                    <p class:invalid={!confirmou}>{msgConfirmacao}</p>
                    <Input
                        type="text"
                        bind:value={token}
                        placeholder="Digite o token"
                    />
                {/if}
                {#if etapa === "senha"}
                    <Input
                        type="password"
                        bind:value={novaSenha}
                        placeholder="Digite a nova senha"
                    />
                    <Input
                        type="password"
                        bind:value={confirmarSenha}
                        placeholder="Confirme a nova senha"
                    />
                {/if}
            </div>
            <div class="modal-footer">
                {#if etapa === "email"}
                    <Button on:click={VerificarEmail}>Enviar</Button>
                {:else if etapa === "token"}
                    <Button variant="outline" on:click={Reenviar}
                        >Reenviar token</Button
                    >
                    <Button on:click={ConfirmaToken}>Confirmar</Button>
                {:else if etapa === "senha"}
                    <Button on:click={AlterarSenha}>Alterar Senha</Button>
                {/if}
            </div>
        </div>
    </div>
{/if}


<style>
    .modal {
        display: flex;
        align-items: center;
        justify-content: center;
        position: fixed;
        z-index: 1050;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        overflow: auto;
        background-color: rgba(0, 0, 0, 0.4);
    }
    .modal-body .invalid {
        color: red;
    }
    .notification-container {
        position: fixed;
        bottom: 50%;
        left: 50%;
        transform: translateX(-50%);
        z-index: 2000;
        opacity: 1;
    }

   .modal-content {
    background-color: #fefefe;
    padding: 20px;
    border: 1px solid #888;
    border-radius: 10px;
    position: relative;
    max-width: 80%; /* Default for mobile */
}

@media (min-width: 768px) { /* Adjust the breakpoint as needed */
    .modal-content {
        max-width: 30%;
    }
}

    .close-button {
        color: #aaa;
        position: absolute;
        right: 10px;
        top: 10px;
        font-size: 20px;
        font-weight: bold;
        border: none;
        background: none;
        cursor: pointer;
    }

    .modal-body {
        display: flex;
        flex-direction: column;
        gap: 10px;
        text-align: center;
    }

    .modal-footer {
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
        flex-wrap: nowrap;
    }

    p {
        margin: 0 0 10px;
    }
</style>
